/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import _ from 'underscore';
import { StatusIconColumn as BaseStatusIconColumn } from '@bingads-webui-campaign/campaignui-common-columns';
import { showPausedCampaignNotifications } from '@bingads-webui-campaign/import-shared-utils';
import { inlineEditSave } from '@bingads-webui-campaign/summary-grid-helper';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import campaignStatus from '../../campaign-status';

export class StatusIconColumn extends BaseStatusIconColumn {
  constructor(options) {
    super(_.extend({}, options, {
      enableEdit: true,
      statusOptions: [
        { name: 'Enabled', value: 'Active' },
        { name: 'Paused', value: 'UserPaused' },
      ],
      group: 'freezing',
      title: options.i18n ? options.i18n.getString('ColumnName_Status') : 'Status',
    }));
  }

  updateStatus({ status, item }) {
    const updatedItem = _.extend({}, item, { Status: status });
    // workaround to fix the bug in bulkupsert api. use 'UserPaused' will get success
    // but actually the request take No effect.
    updatedItem.Status = updatedItem.Status === 'UserPaused' ? 'Paused' : updatedItem.Status;

    const { instrumentation } = this.view;

    const { activity } = instrumentation.createScenarioAndActivity({
      scenarioName: 'PausedCampaignImportNotification',
      activityName: 'CampaignsGridStatusColumn',
    });
    return inlineEditSave(
      {
        id: item.Id,
        fieldName: 'Status',
        updatedItem,
      },
      {
        view: this.view,
        resource: jsData.Campaign,
        i18n: this.i18n,
        i18nErrors,
        editorViewCallbackAfterUpdate: () => {
          const response = [{
            Id: updatedItem.Id,
            Status: status === 'UserPaused' ? campaignStatus.EnumPaused : status,
          }];

          window.App.trigger('campaignUpdated', { data: response });
        },
        importNotificationCallback: () => {
          // show paused campaign notifications based on specific conditions
          showPausedCampaignNotifications({ campaignItemList: [item], updateStatus: status, activity });
        },
        customBlockerTarget: this.isForVNext ? '.campaigns-page' : null,
      }
    );
  }
}
